import CitySEOHead from "@/components/feature/CitySEOHead";
import MariettaHeroSection from "./components/HeroSection";
import MariettaStickyNav from "./components/StickyNav";
import MariettaProcessingTimeSection from "./components/ProcessingTimeSection";
import MariettaServicesSection from "./components/ServicesSection";
import MariettaLocalAreaSection from "./components/LocalAreaSection";
import MariettaTestimonialsSection from "./components/TestimonialsSection";
import MariettaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MariettaComparisonSection from "./components/ComparisonSection";
import MariettaMistakesSection from "./components/MistakesSection";
import MariettaHowItWorksSection from "./components/HowItWorksSection";
import MariettaFAQSection, { faqs } from "./components/FAQSection";
import MariettaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MariettaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function MariettaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Marietta"
        state="Georgia"
        stateAbbr="GA"
        route="/marietta"
        title="Emergency Passport Marietta, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Marietta, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Cobb County and metro Atlanta travelers. Get your emergency passport fast!"
        keywords="expedited passport, emergency passport, Marietta passport, same day passport Atlanta, fast passport Georgia, Cobb County passport"
        geoPlacename="Marietta, Georgia"
        geoPosition="33.9526;-84.5499"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
      />
      <MariettaHeroSection />
      <MariettaStickyNav />
      <MariettaProcessingTimeSection />
      <MariettaServicesSection />
      <MariettaLocalAreaSection />
      <MariettaTestimonialsSection />
      <MariettaAcceptanceFacilitiesSection />
      <MariettaComparisonSection />
      <MariettaMistakesSection />
      <MariettaHowItWorksSection />
      <MariettaFAQSection />
      <MariettaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/marietta" state="GA" />
      <MariettaFinalCTA />
    </div>
  );
}